import { useRef } from 'react';

export const useDropdown = (isSearchable: boolean) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleScrollToViewPort = () => {
        if (containerRef.current && isSearchable) {
            const rect = containerRef.current.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = 84;
            window.scrollTo({
                top: rect.top + scrollTop - offset,
                behavior: 'smooth'
            });
        }
    };

    return { containerRef, handleScrollToViewPort };
};
